<template>
  <div class="type-regist-box-header tree-box-feature-item">
    <v-btn
      outline
      class="UXbtn buttons box-add-btn"
      @click="() => { largeTypeAdd() }"
      :disabled="disabled"
    >
      大分類の追加
    </v-btn>
    <v-btn
      v-if="!isRegist"
      outline
      class="UXbtn buttons remove-btn"
      @click="() => { remove() }"
      :disabled="disabled"
    >削除</v-btn>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'typeRegistBoxHeader',
  props: {
    isRegist: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      'treeNodeSelectedItem'
    ])
  },
  methods: {
    remove () {
      const item = this.treeNodeSelectedItem
      this.$eventBus.$emit('change-is-remove-item', item.id, item.type, false)
    },
    largeTypeAdd () {
      const itemObject = {
        isRemove: false,
        isOpen: true,
        name: '',
        id: this.$uuid.v4(),
        type: 'large',
        isSaveLocal: true,
        children: []
      }

      const parentId = null

      this.$eventBus.$emit('tree-add-item', parentId, itemObject.type, itemObject)
    }
  }
}
</script>

<style lang="scss">
.type-regist-box-header {
  border-top: 1px solid #E8E8E8;
  border-bottom: 1px solid #E8E8E8;
  transform: matrix(1, 0, 0, 1, 0, 0);
  background-color: #F5F5F5;
  height: 40px;
  padding: {
    top: 6px;
    bottom: 7px;
    left: 10px;
    right: 10px;
  }

  .buttons {
    padding: {
      top: 4.5px;
      bottom: 4.5px;
      left: 5px;
      right: 5px;
    }
    border-radius: 3px;

    .v-btn__content {
      font-size: 12px;
    }

    .button-icon {
      font-size: 20px;
      margin-right: 3px;
    }

    &.box-add-btn {
      min-width: auto;
      height: 25px;
    }

    &.remove-btn {
      min-width: 55px;
      height: 25px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/agent/components/typeRegistBoxHeader.vue